/** Transcript persistence so the conversation survives navigation within a tab. */

const KEY = 'crc_chat_transcript';
const NUDGE_KEY = 'crc_chat_nudge_seen';
const MAX_STORED = 40;

export function loadTranscript() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.slice(-MAX_STORED) : [];
  } catch {
    return [];
  }
}

export function saveTranscript(messages) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(messages.slice(-MAX_STORED)));
  } catch {
    /* private mode / quota */
  }
}

export function clearTranscript() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* private mode */
  }
}

export function hasSeenNudge() {
  try {
    return sessionStorage.getItem(NUDGE_KEY) === '1';
  } catch {
    return true;
  }
}

export function markNudgeSeen() {
  try {
    sessionStorage.setItem(NUDGE_KEY, '1');
  } catch {
    /* private mode */
  }
}
